<script setup lang="ts">
defineProps<{
    title: string;
    description?: string;
}>();
</script>

<template>
    <div
        class="flex min-w-0 flex-col gap-5 rounded-2xl border bg-card p-5 shadow-sm"
    >
        <div class="flex flex-wrap items-start justify-between gap-x-4 gap-y-2">
            <div class="min-w-0 flex-1 flex flex-col gap-1">
                <h3 class="text-[15px] font-bold">
                    {{ title }}
                </h3>
                <p
                    v-if="description"
                    class="text-[13px] leading-relaxed text-muted-foreground"
                >
                    {{ description }}
                </p>
            </div>
            <slot name="meta" />
        </div>
        <slot />
    </div>
</template>
